<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getReportTracingAbilityBackwards"
				 @hidden="resetModal">
				 <b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="filterControlCardIds" optionsLabel="name" optionsKey="name" label-cols-sm="4" label-cols-lg="3" label="Control Card" id="filter-" size="sm" :model.sync="filter.controlCardNumber" @input="getFilterControlCardIds" @focus="getFilterControlCardIds" />
						<!-- <app-input-textbox id="fieldset-filter-transaction-type" label-cols-sm="4" label-cols-lg="3" label="Transaction Type " label-for="filter-filter-transaction-type" size="sm" :model.sync="filter.filterTransactionType" /> -->
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="filterControlCardTypes" optionsLabel="name" optionsKey="code" label-cols-sm="4" label-cols-lg="3" label="Control Card Type " id="filter-" size="sm" :model.sync="filter.controlCardType" @input="getControlCardTypes" @focus="getControlCardTypes" />
						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getReportTracingAbilitys"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
						   rounded
						   opacity="0.6"
						   spinner-small
						   spinner-variant="primary"
						   class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Report Tracing Ability Backward</span>
				</b-col>
				<b-col>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download All To Excel</b-button>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-reporttracingabilitybackward" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="light" :bordered="true" :no-local-sorting="true" :items="reportTracingAbilityBackwards" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="reportTracingAbilityBackwards.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="ControlCardType" class="table-filter">
							<v-select append-to-body label="code" :options="filterControlCardTypes" :value="filter.controlCardType" :reduce="item => item.id" v-model="filter.controlCardType" :filterable="true" @input="getReportTracingAbilityBackwardsWithoutLoading" @search="getControlCardTypes"></v-select>
						</b-th>
						<b-th stacked-heading="ControlCardNumber" class="table-filter">
							<b-form-input id="input-control-card-number-table" @input="getReportTracingAbilityBackwardsWithoutLoading" v-model="filter.controlCardNumber" size="sm"></b-form-input>
						</b-th>

					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>
					
					
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-textbox id="fieldset-material-source" label-cols-lg="12"  label="Material Source" label-for="input-material-source" size="sm" :model.sync="row.item.materialSource"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-part-number-source" label-cols-lg="12"  label="Part Number Source" label-for="input-part-number-source" size="sm" :model.sync="row.item.partNumberSource"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-lot-no" label-cols-lg="12"  label="Lot No" label-for="input-lot-no" size="sm" :model.sync="row.item.lotNo"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-wop-number" label-cols-lg="12"  label="WOP Number" label-for="input-wop-number" size="sm" :model.sync="row.item.wopNumber"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-production-date" label-cols-lg="12"  label="Tanggal Produksi (Plan)" label-for="input-production-date" size="sm" :model.sync="row.item.productionDate"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-finish-production-date" label-cols-lg="12"  label="Tanggal Produksi (Actual)" label-for="input-finish-production-date" size="sm" :model.sync="row.item.finishProductionDate"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-control-card-repair" label-cols-lg="12"  label="Control Card Repair" label-for="input-control-card-repair" size="sm" :model.sync="row.item.controlCardRepair"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-control-card-combine-case" label-cols-lg="12"  label="Control Card Combine Case" label-for="input-control-card-combine-case" size="sm" :model.sync="row.item.controlCardCombineCase"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-control-card-fq-qc" label-cols-lg="12"  label="Control Card FQ QC" label-for="input-control-card-fq-qc" size="sm" :model.sync="row.item.controlCardFqQc"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-control-card-repacking" label-cols-lg="12"  label="Control Card Repacking" label-for="input-control-card-repacking" size="sm" :model.sync="row.item.controlCardRepacking"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-change-from" label-cols-lg="12"  label="Change From" label-for="input-change-from" size="sm" :model.sync="row.item.changeFrom"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-machine" label-cols-lg="12"  label="Machine" label-for="input-machine" size="sm" :model.sync="row.item.machine"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-operator-user" label-cols-lg="12"  label="Operator User" label-for="input-operator-user" size="sm" :model.sync="row.item.operatorUser"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-shift" label-cols-lg="12"  label="Shift" label-for="input-shift" size="sm" :model.sync="row.item.shift"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-before" label-cols-lg="12"  label="Qty Before" label-for="input-qty-before" size="sm" :model.sync="row.item.qtyBefore"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-after" label-cols-lg="12"  label="Qty After" label-for="input-qty-after" size="sm" :model.sync="row.item.qtyAfter"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-taken" label-cols-lg="12"  label="Qty Taken" label-for="input-qty-taken" size="sm" :model.sync="row.item.qtyTaken"   :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="d-flex justify-content-center">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
											  v-model="currentPage"
											  :total-rows="(reportTracingAbilityBackwardsPaging != null ? reportTracingAbilityBackwardsPaging.dataCount : 0)"
											  :per-page="(reportTracingAbilityBackwardsPaging != null ? reportTracingAbilityBackwardsPaging.pageSize : 0)"
											  aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template><style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-reporttracingabilitybackward.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-reporttracingabilitybackward.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import ReportTracingAbilityBackward from '@/models/ReportTracingAbilityBackward/ReportTracingAbilityBackward';
import ReportTracingAbilityBackwardList from '@/models/ReportTracingAbilityBackward/ReportTracingAbilityBackwardList';
import ReportTracingAbilityBackwardFilter from '@/filters/ReportTracingAbilityBackward/ReportTracingAbilityBackwardFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import ControlCardType from '@/models/ControlCardType/ControlCardType';

export default {
	components : {
		ReportTracingAbilityBackward, 
		ReportTracingAbilityBackwardList, 
		ReportTracingAbilityBackwardFilter, 
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextbox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		PopupDownload,
		PopupPDF,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : {"class" : "th-number d-stack-none"}},
				{"customerName": {}, "class" : "th-customer-name d-stack-none", "label" : "Customer Name", key: 'customerName', }, 
				{"partNumber": {}, "class" : "th-part-number last-child", "label" : "Part Number", key: 'partNumber', }, 
				{"partClassification": {}, "class" : "th-part-classification d-stack-none", "label" : "Part Classification", key: 'partClassification', }, 
				{"supplierCode": {}, "class" : "th-supplier-code d-stack-none", "label" : "Supplier Code", key: 'supplierCode', }, 
				{"lineCode": {}, "class" : "th-line-code d-stack-none", "label" : "Line Code", key: 'lineCode', }, 
				{"rackCode": {}, "class" : "th-rack-code d-stack-none", "label" : "Rack Code", key: 'rackCode', }, 
				{"seqProcess": {}, "class" : "th-seq-process d-stack-none", "label" : "Seq Process", key: 'seqProcess', }, 
				{"pic1": {}, "class" : "th-pic-1 d-stack-none", "label" : "Pic 1", key: 'pic1', }, 
				{"pic2": {}, "class" : "th-pic-2 d-stack-none", "label" : "Pic 2", key: 'pic2', }, 
				{"areaName": {}, "class" : "th-area-name d-stack-none", "label" : "Area Name", key: 'areaName', }, 
				{"transactionType": {}, "class" : "th-transaction-type d-stack-none", "label" : "Transaction Type", key: 'transactionType', }, 
				{"transactionDate": {}, "class" : "th-transaction-date d-stack-none", "label" : "Transaction Date", key: 'transactionDate', }, 
				{"controlCardNumber": {}, "class" : "th-control-card-number", "label" : "Control Card Number", key: 'controlCardNumber', }, 
				{"qtyAfter": {}, "class" : "th-qty-after d-stack-none", "label" : "Qty After", key: 'qtyAfter', }, 
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			reportTracingAbilityBackwards: [],
			reportTracingAbilityBackwardsPaging: {},
			filterControlCardIds : [],
			filterPartNumbers : [],
			filterWopNumbers : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			filterControlCardTypes: [],
		}
	},	methods : {
		getControlCardTypes: async function (input) {
			let filter = {};
			if(input != null)
			{
				filter.code = input;
			}
			let result = await ControlCardType.getList(this, filter, null, 0, 10);
			this.filterControlCardTypes = result.data;
		},
		getReportTracingAbilityBackwards : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			if(this.filter.controlCardNumber)
			{
				this.filter.exactType.controlCardNumber = 1
			}
			if(this.filter.controlCardType)
			{
				this.filter.exactType.controlCardType = 1
			}
			ReportTracingAbilityBackward.getListCustomUrl(this, "getlistcustom", this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportTracingAbilityBackwards = result.data;
					if(result.fields != null && result.fields.length > 0)
					{
						this.fields = result.fields;
					}
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getReportTracingAbilityBackwardsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ReportTracingAbilityBackward.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportTracingAbilityBackwards = result.data
					this.reportTracingAbilityBackwardsPaging = result
				}
			})
			.catch(error => {});
		},
		getFilterControlCardIds : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportTracingAbilityBackward.getListCustomUrl(this,'getlistfiltercontrolcardid' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterControlCardIds = result.data
				}
			})
			.catch(error => {});
		},
		getFilterPartNumbers : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportTracingAbilityBackward.getListCustomUrl(this,'getlistfilterpartnumber' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterPartNumbers = result.data
				}
			})
			.catch(error => {});
		},
		getFilterWopNumbers : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportTracingAbilityBackward.getListCustomUrl(this,'getlistfilterwopnumber' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterWopNumbers = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new ReportTracingAbilityBackwardFilter();
			this.getReportTracingAbilityBackwards();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getReportTracingAbilityBackwards();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ReportTracingAbilityBackward.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ReportTracingAbilityBackward.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			ReportTracingAbilityBackward.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			ReportTracingAbilityBackward.deleteData(this, id).then(result => {
				if (result)
				{
					this.getReportTracingAbilityBackwards();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ReportTracingAbilityBackward.deleteMultipleData(this).then(result => {
					this.getReportTracingAbilityBackwards();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableReportTracingAbilityBackwardParent = document.getElementById('table-list-reporttracingabilitybackward').parentNode;
			tableReportTracingAbilityBackwardParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableReportTracingAbilityBackwardParent.scrollWidth - tableReportTracingAbilityBackwardParent.offsetWidth) == Math.ceil(tableReportTracingAbilityBackwardParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableReportTracingAbilityBackwardParent = document.getElementById('table-list-reporttracingabilitybackward').parentNode;
			tableReportTracingAbilityBackwardParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableReportTracingAbilityBackwardParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ReportTracingAbilityBackwardFilter();
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Report Tracing Ability Backward"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getReportTracingAbilityBackwards();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getReportTracingAbilityBackwards();
			}
		},
		sortDesc: {
			handler: function() {
				this.getReportTracingAbilityBackwards();
			}
		},
		currentPage: {
			handler: function() {
				this.getReportTracingAbilityBackwards();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getReportTracingAbilityBackwards();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ReportTracingAbilityBackward.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "reporttracingabilitybackwardindex") {
					this.getReportTracingAbilityBackwardsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "report_tracing_ability_backward").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
